import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "p-[10px] w-full relative" }
const _hoisted_3 = { class: "text-sm font-bold text-center text-black h-[40px] flex" }
const _hoisted_4 = { class: "d-block m-auto" }
const _hoisted_5 = { class: "text-gray-700 my-[10px] w-full text-center text-xs font-semibold" }
const _hoisted_6 = { class: "flex w-full relative justify-center z-40 items-center text-black flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<a target=\"_blank\" href=\"mailto:service.client@ironsecur.com\" class=\"my-[5px] mx-[10px] ml-[0px] text-sm\"><i class=\"fa-solid fa-envelope\"></i></a><a target=\"_blank\" href=\"tel:+22943480141\" class=\"my-[5px] mx-[10px] ml-[0px] text-sm\"><i class=\"fa-solid fa-phone\"></i></a><a target=\"_blank\" href=\"https://wa.me/+22943480141\" class=\"my-[5px] mx-[10px] ml-[0px] text-sm\"><i class=\"fa-brands fa-whatsapp\"></i></a>", 3)
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-linkedin" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "window absolute bottom-0 h-[375px] text-white font-semibold text-xs flex justify-center items-start w-full translate-y-[100%] p-[20px] ease-in-out duration-300" }
const _hoisted_14 = { class: "max-h-[260px] oa overflow-auto" }
const _hoisted_15 = { class: "mb-[10px]" }

import { ref, onMounted } from 'vue';
import EmployeeProfile from '@/components/types/EmployeeProfile';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeProfileCardComponent',
  props: {
    profile: {}
  },
  setup(__props: any) {

const props = __props;

const windowDiv = ref<HTMLElement | null>(null);
const requireImages = require.context('@/assets/img/employee', false, /\.(png|jpe?g)$/)

const getImagePath = (fileName: string) => {
        try {
            return requireImages(`./${fileName}`)
        } catch (error) {
            return ''
        }
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "windowDiv",
    ref: windowDiv,
    class: "staff w-[90%] h-[375px] cursor-pointer overflow-hidden max-w-[250px] m-[10px] rounded-[20px] border relative bg-white"
  }, [
    _createElementVNode("img", {
      src: getImagePath(props.profile.photoName),
      alt: "",
      class: "rounded-t-[15px] w-full h-[248px] bg-cover"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.profile.work), 1)
      ]),
      _createElementVNode("p", _hoisted_5, _toDisplayString(props.profile.name), 1),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("a", {
          target: "_blank",
          href: props.profile.linkdinProfile,
          class: "my-[5px] mx-[10px] ml-[0px] text-sm"
        }, _hoisted_12, 8, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(props.profile.description_attribute)), 1)
      ])
    ])
  ], 512))
}
}

})